:host {
    display: contents;
    height: 100%;
    --scroll-padding-y: 0px;
    --scroll-total-height: 0px;

}

.virtual-scroll-container {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: var(--ux-scroll-container-height, 100%);
    position: relative;
    scrollbar-width: 15px;
    margin-right: -15px;
}

::slotted(*) {
    display: none; // Hide the original slot content
}

.virtual-scroll-item {
    flex: 0 0 auto;
}

#inner-transform-container {
    transform: translateY(var(--scroll-padding-y))
}

#outer-transform-containe {
    height: var(--scroll-total-height)
}